<div class="category" (click)="onOpen($event.target)">
  <hyperkit-typography
    variant="emphasized"
    size="sm"
    align="left"
    color="secondary"
    >{{ name }}</hyperkit-typography
  >
  <span>{{ count }}</span>
  <i class="k-icon k-font-icon k-i-arrow-chevron-down"></i>
</div>
<div class="category-tags">
  <ul>
    @for (tag of filteredTags; track tag) {
      <li>
        <hyperkit-checkbox
          (click)="onSelect(tag.key)"
          [checked]="isChecked(filterType, tag.key)"
          [value]="tag.key"
          [label]="tag.key"
        >
        </hyperkit-checkbox>
        <span>{{ tag.doc_count }}</span>
      </li>
    }
  </ul>
</div>
